// src/utils/api.js
import axios from "axios";

// -------------------------------------
// 🔗 BASE URL RESOLUTION (Dev vs Prod)
// -------------------------------------

const FALLBACK_LOCAL = "http://localhost:5000/api";

// ✅ Oracle backend (HTTPS) + /api
const FALLBACK_PROD = "https://api.80-225-211-151.nip.io/api";

let baseURL = FALLBACK_LOCAL;

try {
  let rawBase = null;

  // ✅ Vite style (if ever used)
  if (
    typeof import.meta !== "undefined" &&
    import.meta &&
    import.meta.env &&
    import.meta.env.VITE_API_BASE_URL
  ) {
    rawBase = import.meta.env.VITE_API_BASE_URL;
  }
  // ✅ CRA style (your Vercel env)
  else if (typeof process !== "undefined" && process.env) {
    // Accept BOTH names (so you can use either in Vercel)
    rawBase =
      process.env.REACT_APP_API_URL ||
      process.env.REACT_APP_API_BASE_URL ||
      null;
  }

  if (rawBase) {
    // rawBase should be like "https://api.80-225-211-151.nip.io"
    baseURL = rawBase.replace(/\/+$/, "") + "/api";
  } else if (typeof window !== "undefined") {
    const host = window.location.hostname;

    const isLocal =
      host === "localhost" ||
      host === "127.0.0.1" ||
      host.startsWith("192.168.") ||
      host.endsWith(".local");

    baseURL = isLocal ? FALLBACK_LOCAL : FALLBACK_PROD;
  }
} catch (e) {
  baseURL = FALLBACK_LOCAL;
}

console.log("[Passiify] API baseURL =", baseURL);

const API = axios.create({
  baseURL,
});

// -------------------------------------
// 🔐 INTERCEPTOR: ATTACH TOKENS
// -------------------------------------
API.interceptors.request.use(
  (config) => {
    const userToken = localStorage.getItem("token");
    const partnerToken = localStorage.getItem("partnerToken");
    const adminToken = localStorage.getItem("adminToken");

    const url = config.url || "";
    const isAdminRoute = url.startsWith("/admin") || url.startsWith("admin");

    config.headers = {
      ...(config.headers || {}),
    };

    // 👑 Admin routes → admin token
    if (isAdminRoute) {
      if (adminToken) {
        config.headers.Authorization = `Bearer ${adminToken}`;
      }
      return config;
    }

    // 🤝 Partner routes
    const isPartnerRoute =
      url.startsWith("/gyms/me") ||
      url.startsWith("gyms/me") ||
      url.startsWith("/bookings") ||
      url.startsWith("bookings") ||
      url.startsWith("/events/host") ||
      url.startsWith("events/host") ||
      url.startsWith("/events/my") ||
      url.startsWith("events/my") ||
      url.startsWith("/event-bookings") ||
      url.startsWith("event-bookings");

    if (isPartnerRoute) {
      if (partnerToken) {
        config.headers.Authorization = `Bearer ${partnerToken}`;
      } else if (userToken) {
        config.headers.Authorization = `Bearer ${userToken}`;
      }
      return config;
    }

    // 👤 Normal user routes
    if (userToken) {
      config.headers.Authorization = `Bearer ${userToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default API;
